import QRCode from "react-qr-code"
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom'
import { Button, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import PageWrapper from '/components/page-wrapper'
import { AppContext } from '/providers/app-context'
import HelpText from '/help/pass-installer'
import Menu from '/components/passes/pass-nav-menu'

import { getPass } from '/providers/passes-api'
import StyledPaper from "../components/paper.jsx"

import appleButton from '/assets/images/add-to-apple-wallet.svg'
import googleButton from '/assets/images/add-to-google-wallet.svg'

const PassInstaller = () => {

  const navigate = useNavigate()

  const { templates } = useContext(AppContext)
  const { templateId, passId } = useParams()
  const { apiSource, apiKey } = useContext(AppContext)

  const location = useLocation()

  const [pass, setPass] = useState(location.state?.pass)

  const template = useMemo(() => { return templates.filter(t => t.id === templateId)[0] }, [templates, templateId])

  useEffect(() => {
    if (!location.state) getPassData()
  }, [templateId, passId])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKey, templateId, passId })
    if (p.ok === false) navigate("/templates")
    setPass(p.pass)
  }

  return (
    <PageWrapper title="Pass Messages" HelpText={HelpText} heading={`${pass.pass_id} ${pass.mode === "test" ? " [test]" : ""}`} menu={<Menu pass={pass} template={template} />}>
      <div className='overflow-auto h-full pb-10'>
        <Content pass={pass} />
      </div>
    </PageWrapper>
  )
}

export default PassInstaller

const Content = ({ pass }) => {

  const { copyingEmail, setCopyingEmail } = useContext(AppContext)

  const [emailBarcodes, setEmailBarcodes] = useState(false)

  useEffect(() => {
    if (copyingEmail) {
      document.execCommand("SelectAll", true)
      document.execCommand("Copy", true)
      document.execCommand("UnSelect", true)

      setCopyingEmail(false)
      setEmailBarcodes(false)
    }
  }, [copyingEmail])

  const copyEmail = () => {
    setCopyingEmail(true)
  }

  const copyEmailBarcodes = () => {
    setEmailBarcodes(true)
    setCopyingEmail(true)
  }

  if (copyingEmail) return (
    <div style={{ backgroundColor: "#fff", width: "100%" }}>
      <br />
      <table cellPadding={20} cellSpacing={20}>
        <tbody>
          <tr style={{ height: 100 }}>
            <td><Link to={pass?.apple_url} target='_pass'><img src={appleButton} width={250} /></Link></td>
            <td><Link to={pass?.google_url} target='_pass'><img src={googleButton} width={250} /></Link></td>
          </tr>
          {emailBarcodes &&
            <tr style={{ height: 200, width: 200 }}>
              <td >
                <div className='bg-white p-5'>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={pass?.apple_url}
                    viewBox={`0 0 256 256`}
                  />
                </div>
              </td>

              <td >
                <div className='bg-white p-5'>
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={pass?.google_url}
                    viewBox={`0 0 256 256`} />
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <br /><br />
    </div>
  )


  if (pass) return (
    <div className='flex flex-row gap-40 items-center m-10 justify-around'>

      <StyledPaper>
        <div className='flex flex-row gap-20 p-5'>
          <div className='flex flex-col gap-10 items-start'>
            <div style={{ height: 100 }} className="flex flex-col justify-around">
              <Link to={pass.apple_url} target='_pass'><img src={appleButton} width={250} /></Link>
            </div>

            <div style={{ height: 250, width: 250 }} className='bg-white p-5' >
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={pass.apple_url}
                viewBox={`0 0 256 256`}
              />
            </div>

            <CopyToClipboard text={pass.apple_url} onCopy={() => enqueueSnackbar({ message: 'Apple install URL copied', variant: 'success' })}>
              <Button><ContentCopyIcon color='inherit' className="mr-5" />Copy URL to clipboard</Button>
            </CopyToClipboard>
          </div>

          <div className='flex flex-col gap-10 items-start'>
            <div style={{ height: 100 }} className="flex flex-col justify-around">
              <Link to={pass.google_url} target='_pass'><img src={googleButton} width={250} /></Link>
            </div>

            <div style={{ height: 250, width: 250 }} className='bg-white p-5'>
              <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={pass.google_url}
                viewBox={`0 0 256 256`}
              />
            </div>

            <CopyToClipboard text={pass.google_url} onCopy={() => enqueueSnackbar({ message: 'Google install URL copied', variant: 'success' })}>
              <Button><ContentCopyIcon color='inherit' className="mr-5" />Copy URL to clipboard</Button>
            </CopyToClipboard>
          </div>
        </div>
      </StyledPaper>

      <StyledPaper>
        <div className='flex flex-col gap-5 p-5'>
          <Typography variant='h6'>Pass ID:
            <CopyToClipboard text={pass.pass_id} onCopy={() => enqueueSnackbar({ message: 'Gift card ID copied', variant: 'success' })} options={{ format: 'text/plain' }}>
              <Button ><ContentCopyIcon color='inherit' className="mr-5" />{pass.pass_id}</Button>
            </CopyToClipboard>
          </Typography>

          <Button variant='contained' color="secondary" onClick={copyEmailBarcodes}><ContentCopyIcon color='inherit' className="mr-5" />Copy email content (with barcodes)</Button>
          <Button variant='contained' color="secondary" onClick={copyEmail}><ContentCopyIcon color='inherit' className="mr-5" />Copy email content (no barcodes)</Button>
        </div>
      </StyledPaper>
    </div>
  )
}